import { ThemeProvider } from '@ori-ui/mui';
import { UniversalTokenProvider } from '@ori/auth';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { APP_NAME } from './constants';
import { ErrorBoundary } from './containers';
import { parseSpaConfig } from './utils';
import type { AppConfiguration } from '~/models';

export const render = async (rootElement: HTMLElement): Promise<boolean> => {
  if (!rootElement.dataset.config) {
    return false;
  }
  const config = parseSpaConfig(rootElement.dataset.config, [
    'currentLanguage',
    'customerId',
    'staticApiUrl',
    'tenant',
  ]);
  const configuration: AppConfiguration = {
    currentLanguage:
      typeof __CURRENT_LANGUAGE__ === 'string' ? __CURRENT_LANGUAGE__ : config.currentLanguage,
    customerId: config.customerId,
    staticApiUrl: config.staticApiUrl,
    tenant: typeof __TENANT__ === 'string' ? __TENANT__ : config.tenant,
  };
  createRoot(rootElement).render(
    <ErrorBoundary>
      <UniversalTokenProvider
        customerId={config.customerId}
        initialToken=""
      >
        <ThemeProvider
          enableCacheProvider
          cacheKey={APP_NAME}
        >
          <App configuration={configuration} />
        </ThemeProvider>
      </UniversalTokenProvider>
    </ErrorBoundary>,
  );

  return true;
};
